module.exports = __webpack_public_path__ + "static/media/vtex35.b39755fb.png";